import Vue from 'vue';
import Component from './fliggy-order-detail-dialog';

const ComponentConstructor = Vue.extend(Component);


export default {
  instance: null,
  show(data) {
    return new Promise((resolve, reject) => {
      this.hide();
      this.instance = new ComponentConstructor({
        el: document.createElement('div'),
        data: {
          params: {
            ota_sub_order_id: data.ota_sub_order_id,
            onRefresh: data.onRefresh,
            resolve,
            reject,
            onClose: () => {
              this.instance = null;
            },
          },
        },
      });

      document.body.appendChild(this.instance.$el);
    });
  },
  hide() {
    if (this.instance) {
      document.body.removeChild(this.instance.$el);
      this.instance = null;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/ota/fliggy-order-detail-dialog/index.js